module.exports = __webpack_public_path__ + "static/img/home_steps.a9aa39f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_steps.png
// module id = lr5y
// module chunks = 1